module.exports = __webpack_public_path__ + "img/cloudy.6c4ad6ae.png";